import { Component } from "react";

const canUseDOM = () => {
  if (
    typeof window === "undefined" ||
    !window.document ||
    !window.document.createElement
  ) {
    return false;
  }
  return true;
};

export const ZendeskAPI = (...args: any[]) => {
  if (canUseDOM() && (window as any).zE) {
    (window as any).zE.apply(null, args);
  } else {
    console.warn("Zendesk is not initialized yet");
  }
};

interface ZendeskProps {
  onLoaded: () => void;
  zendeskKey: string;
  defer?: boolean;
}

export default class Zendesk extends Component<ZendeskProps> {
  constructor(props: ZendeskProps) {
    super(props);
    this.insertScript = this.insertScript.bind(this);
    this.onScriptLoaded = this.onScriptLoaded.bind(this);
  }

  onScriptLoaded() {
    if (typeof this.props.onLoaded === "function") {
      this.props.onLoaded();
    }
  }

  insertScript(zendeskKey: string, defer?: boolean) {
    const script = document.createElement("script");
    if (defer) {
      script.defer = true;
    } else {
      script.async = true;
    }
    script.id = "ze-snippet";
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    script.addEventListener("load", this.onScriptLoaded);
    document.body.appendChild(script);
  }

  componentDidMount() {
    if (canUseDOM() && !(window as any).zE) {
      const { defer, zendeskKey, ...other } = this.props;
      this.insertScript(zendeskKey, defer);
      (window as any).zESettings = other;
    }
  }

  componentWillUnmount() {
    if (!canUseDOM || !(window as any).zE) {
      return;
    }
    document.getElementById("ze-snippet")?.remove();
    document.querySelector(`div[style*="z-index: 987654321"]`)?.remove();
    document
      .querySelector(`iframe[style*="z-index: 987654321"]`)
      ?.parentElement?.remove();
    delete (window as any).zE;
    delete (window as any).zESettings;
  }

  render() {
    return null;
  }
}
